var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChilliSauce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 5H14C14.5523 5 15 5.44772 15 6V7C15.5523 7 16 7.44772 16 8V18.25H8V8C8 7.44772 8.44772 7 9 7V6C9 5.44772 9.44772 5 10 5H10.375L11.3244 2.46816C11.43 2.18656 11.6992 2 12 2C12.3008 2 12.57 2.18656 12.6756 2.46816L13.625 5ZM11.2235 10.8095C11.4628 11.6302 11.474 12.7427 10.5484 13.6C9.25272 14.8 10.5888 15.7 11.1286 16C10.1569 13.9 12.5268 13.2464 12.4919 13.3C12.1004 13.9 12.4919 15 12.8158 15.7C15.2739 13.2164 13.4122 11.298 11.676 10.368C11.4232 10.2326 11.1432 10.5342 11.2235 10.8095Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.75V21C8 21.5523 8.44772 22 9 22H15C15.5523 22 16 21.5523 16 21V19.75H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilliSauce);
export default __webpack_public_path__ + "static/media/chilli-sauce.9de6141906c672f760cabb5c798ef160.svg";
export { ForwardRef as ReactComponent };